import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.page.html',
  styleUrls: ['./exchange.page.scss'],
})
export class ExchangePage implements OnInit {

  coin = 1;
  constructor(private navCtrl: NavController) { }

  ngOnInit() {
    const bond = Security.getCoin();
    if (bond === '1') {
      this.coin = 1;
    }

    if (bond === '2') {
      this.coin = 2;
    }

    if (bond === '3') {
      this.coin = 3;
    }
  }

  goToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }

}
